import { BiChevronDown } from "react-icons/bi";
import { AiFillStar } from "react-icons/ai";
import { useData } from "../../context/data-context";

export const FilterBar = () => {
  const { state, dispatch } = useData();

  const dispatchHandler = (dispatchType, dispatchPayload) => {
    dispatch({
      type: dispatchType,
      payload: dispatchPayload,
    });
  };

  return (
    <div>
      <div className="filter-sec">
        <h2>Search Results</h2>
        <div className="filters-con">
          <div>
            <h4>
              Brand
              <span>
                <BiChevronDown size={22} />
              </span>
            </h4>
            <label>
              <input
                type="checkbox"
                id="mobile"
                name="brandCategory"
                checked={state.brand.smartphones}
                onChange={() =>
                  dispatchHandler("CATEGORY_FILTER", {
                    category: "smartphones",
                  })
                }
              />
              Smartphones
            </label>
            <label>
              <input
                type="checkbox"
                id="laptop"
                name="brandCategory"
                checked={state.brand.laptops}
                onChange={() =>
                  dispatchHandler("CATEGORY_FILTER", {
                    category: "laptops",
                  })
                }
              />
              Laptops
            </label>
          </div>
          <div>
            <h4>
              Price Range
              <span>
                <BiChevronDown size={22} />
              </span>
            </h4>
            <label>
              <input
                type="checkbox"
                id="under500"
                name="priceCategory"
                checked={state.priceRange.under500}
                onChange={() =>
                  dispatchHandler("PRICERANGE_FILTER", {
                    priceRange: "under500",
                  })
                }
              />
              Under 500
            </label>
            <label>
              <input
                type="checkbox"
                id="price1000To3000"
                name="priceCategory"
                checked={state.priceRange.price1000To3000}
                onChange={() =>
                  dispatchHandler("PRICERANGE_FILTER", {
                    priceRange: "price1000To3000",
                  })
                }
              />
              1000 to 3000
            </label>
          </div>
          <div>
            <h4>
              Ratings
              <span>
                <BiChevronDown size={22} />
              </span>
            </h4>

            <label>
              <input
                type="checkbox"
                id="star5"
                name="ratingCategory"
                checked={state.ratings.star5}
                onChange={() =>
                  dispatchHandler("RATINGS_FILTER", {
                    rating: "star5",
                  })
                }
              />
              <AiFillStar className="rating" size={22} />
              <AiFillStar className="rating" size={22} />
              <AiFillStar className="rating" size={22} />
              <AiFillStar className="rating" size={22} />
              <AiFillStar className="rating" size={22} />
            </label>
            <label>
              <input
                type="checkbox"
                id="star4"
                name="ratingCategory"
                checked={state.ratings.star4}
                onChange={() =>
                  dispatchHandler("RATINGS_FILTER", {
                    rating: "star4",
                  })
                }
              />
              <AiFillStar className="rating" size={22} />
              <AiFillStar className="rating" size={22} />
              <AiFillStar className="rating" size={22} />
              <AiFillStar className="rating" size={22} />
              <AiFillStar className="grey-text" size={22} />
            </label>
            <label>
              <input
                type="checkbox"
                id="star3"
                name="ratingCategory"
                checked={state.ratings.star3}
                onChange={() =>
                  dispatchHandler("RATINGS_FILTER", {
                    rating: "star3",
                  })
                }
              />
              <AiFillStar className="rating" size={22} />
              <AiFillStar className="rating" size={22} />
              <AiFillStar className="rating" size={22} />
              <AiFillStar className="grey-text" size={22} />
              <AiFillStar className="grey-text" size={22} />
            </label>
            <label>
              <input
                type="checkbox"
                id="star2"
                name="ratingCategory"
                checked={state.ratings.star2}
                onChange={() =>
                  dispatchHandler("RATINGS_FILTER", {
                    rating: "star2",
                  })
                }
              />
              <AiFillStar className="rating" size={22} />
              <AiFillStar className="rating" size={22} />
              <AiFillStar className="grey-text" size={22} />
              <AiFillStar className="grey-text" size={22} />
              <AiFillStar className="grey-text" size={22} />
            </label>
            <label>
              <input
                type="checkbox"
                id="star1"
                name="ratingCategory"
                checked={state.ratings.star1}
                onChange={() =>
                  dispatchHandler("RATINGS_FILTER", {
                    rating: "star1",
                  })
                }
              />
              <AiFillStar className="rating" size={22} />
              <AiFillStar className="grey-text" size={22} />
              <AiFillStar className="grey-text" size={22} />
              <AiFillStar className="grey-text" size={22} />
              <AiFillStar className="grey-text" size={22} />
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};
